module.exports = __webpack_public_path__ + "img/boy_001.3fbda13c.jpg";